<template>
  <section id="dropdowns">
    <div class="demo">
      <h5>Dropdown</h5>
      <div class="row">
        <div class="col-sm-4">
          <div class="dropdown">
            <button class="btn btn-ctrl dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="dot-green mr-1"></span>
              Active
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
              <button class="dropdown-item" type="button">
                <span class="dot-gray mr-1"></span>
                Inactive
              </button>
              <button class="dropdown-item" type="button">
                <span class="dot-teal mr-1"></span>
                In talent pool
              </button>
              <button class="dropdown-item" type="button">
                <span class="dot-blue mr-1"></span>
                Active
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dropdown">
            <button class="btn btn-ctrl dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Actions
            </button>
            <div class="dropdown-menu dropdown-menu-right p-0" aria-labelledby="dropdownMenuButton">
              <div class="vh-30 overflow-y-auto scroll p-3">
                <a class="dropdown-item" href="#">Action 1</a>
                <a class="dropdown-item" href="#">Action 2</a>
                <a class="dropdown-item" href="#">Action 3</a>
                <a class="dropdown-item" href="#">Action 4</a>
                <a class="dropdown-item" href="#">Action 5</a>
                <a class="dropdown-item" href="#">Action 6</a>
                <a class="dropdown-item" href="#">Action 7</a>
                <a class="dropdown-item" href="#">Action 8</a>
                <a class="dropdown-item" href="#">Action 9</a>
                <a class="dropdown-item" href="#">Action 10</a>
                <a class="dropdown-item" href="#">Action 11</a>
                <a class="dropdown-item" href="#">Action 12</a>
                <a class="dropdown-item" href="#">Action 13</a>
                <a class="dropdown-item" href="#">Action 14</a>
                <a class="dropdown-item" href="#">Action 15</a>
                <a class="dropdown-item" href="#">Action 16</a>
                <a class="dropdown-item" href="#">Action 17</a>
                <a class="dropdown-item" href="#">Action 18</a>
                <a class="dropdown-item" href="#">Action 19</a>
                <a class="dropdown-item" href="#">Action 20</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dropdown d-inline-block">
            <button class="btn btn-ctrl btn-sm dropdown-toggle no-caret mr-0" type="button" title="Actions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="gel-icon-ellipsis"></i>
            </button>
             <div class="dropdown-menu dropdown-menu-right">
              <a class="dropdown-item" href="#">Action 1</a>
              <a class="dropdown-item" href="#">Action 2</a>
              <a class="dropdown-item" href="#">Action 3</a>
              <a class="dropdown-item" href="#">Action 4</a>
              <a class="dropdown-item" href="#">Action 5</a>
             </div>  
          </div>
        </div>
      </div>
      <hr class="sg-hr">
      <h5>Dropup</h5>
      <div class="row">
        <div class="col-sm-6">
          <!-- <div class="dropup d-inline"> <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">English </a> <div class="dropdown-menu dropdown-menu-right" aria-expanded="true"> <a class="dropdown-item"
          href="#1">English (US)</a> <a class="dropdown-item" href="#2">Español (Spanish)</a> <a class="dropdown-item" href="#3">Deutsch (German)</a> <a class="dropdown-item" href="#4">简体中文 (Chinese, Simplified)</a> <a class="dropdown-item" href="#5">日本語
          (Japanese)</a> <a class="dropdown-item" href="#6">Nederlands (Dutch)</a> </div> </div> -->
          <div class="btn-group dropup">
            <button type="button" class="btn btn-sm btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Dropup
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#1">English (US)</a>
              <a class="dropdown-item" href="#2">Español (Spanish)</a>
              <a class="dropdown-item" href="#3">Deutsch (German)</a>
              <a class="dropdown-item" href="#4">简体中文 (Chinese, Simplified)</a>
              <a class="dropdown-item" href="#5">日本語 (Japanese)</a>
              <a class="dropdown-item" href="#6">Nederlands (Dutch)</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import mdfile from "@/docs/components/dropdowns.md";
export default {
  name: "dropdowns",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.dropdowns.name);
    this.$emit("update-tagline", this.$root.yamlData.components.dropdowns.description);
  },
  mounted: function () {
    const dropdowns = document.querySelectorAll('[data-toggle="dropdown"]')
    dropdowns.forEach(dropdown => {
      new BSN.Dropdown(dropdown)
    })
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
